import { TEXT, initialLang } from "./guest/i18n";

// What main.jsx shows when the app cannot start or crashes. The guest screens
// speak the guest's language (spec T8: every guest-visible string in TR and
// EN) and read it the way the guest page does, from i18n.js; the staff screens
// are Turkish and stay as they were.

const wrap = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  width: "100vw",
  textAlign: "center",
  padding: "2rem",
  background: "#ffffff",
  color: "#333333",
  boxSizing: "border-box",
};
const reloadButton = {
  padding: "0.6rem 1.5rem",
  borderRadius: "8px",
  border: "none",
  background: "#6366f1",
  color: "#fff",
  cursor: "pointer",
};
const reload = () => window.location.reload();

function guestText() {
  const lang = initialLang();
  return (key) => TEXT[lang][key] ?? TEXT.tr[key];
}

// The crash screen the staff app has always had.
function StaffCrash() {
  return (
    <div style={wrap}>
      <h1 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: "1rem" }}>
        Beklenmedik Bir Hata Oluştu
      </h1>
      <p style={{ marginBottom: "1.5rem" }}>
        Sorun otomatik olarak bildirildi. Lütfen sayfayı yenileyin.
      </p>
      <button onClick={reload} style={reloadButton}>
        Sayfayı Yenile
      </button>
    </div>
  );
}

function GuestCrash() {
  const t = guestText();
  return (
    <div style={wrap}>
      <h1 style={{ fontSize: "1.5rem", marginBottom: "1rem" }}>{t("boot.crashTitle")}</h1>
      <p style={{ marginBottom: "1.5rem" }}>{t("boot.crashBody")}</p>
      <button onClick={reload} style={reloadButton}>{t("boot.reload")}</button>
    </div>
  );
}

export function CrashScreen({ guest }) {
  return guest ? <GuestCrash /> : <StaffCrash />;
}

// A script chunk (the guest page, the app) failed to download: a retry screen
// instead of a blank page.
export function LoadFailedScreen({ guest }) {
  const t = guest ? guestText() : null;
  return (
    <div style={wrap} role="alert">
      <p style={{ marginBottom: "1.5rem" }}>
        {guest ? t("boot.loadFailed") : "Uygulama yüklenemedi. Bağlantınızı kontrol edip sayfayı yenileyin."}
      </p>
      <button onClick={reload} style={reloadButton}>
        {guest ? t("retry") : "Sayfayı Yenile"}
      </button>
    </div>
  );
}
